import { render, staticRenderFns } from "./centerCard.vue?vue&type=template&id=61d2625f&scoped=true"
import script from "./centerCard.vue?vue&type=script&lang=js"
export * from "./centerCard.vue?vue&type=script&lang=js"
import style0 from "./centerCard.vue?vue&type=style&index=0&id=61d2625f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d2625f",
  null
  
)

export default component.exports